import { render, staticRenderFns } from "./OzlContractItemChangeStatusDialog.vue?vue&type=template&id=0b455301"
import script from "./OzlContractItemChangeStatusDialog.vue?vue&type=script&lang=js"
export * from "./OzlContractItemChangeStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports